// extracted by mini-css-extract-plugin
export default {"invalid":"InvalidInput_invalid__CRP-y","heading-name":"InvalidInput_heading-name__VyyvG","contents":"InvalidInput_contents__CCXTi"};